import { useEffect, useState } from 'react';
import { modulosAPI } from '../lib/api';

/**
 * Hook que carrega os módulos extras ativos para o tenant logado.
 * Faz polling leve a cada 60s para detectar ativação/desativação.
 */
export function useModulosAtivos() {
  const [modulos, setModulos] = useState({ financeiro: { ativo: false, valor: 100 } });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const res = await modulosAPI.ativos();
        if (mounted) setModulos(res.data || {});
      } catch (_) {
        // silent
      } finally {
        if (mounted) setLoading(false);
      }
    };
    load();
    const id = setInterval(load, 60000);
    return () => { mounted = false; clearInterval(id); };
  }, []);

  return {
    modulos,
    loading,
    financeiroAtivo: !!modulos?.financeiro?.ativo,
    whatsappAtivo: !!modulos?.whatsapp?.ativo,
  };
}
